// extracted by mini-css-extract-plugin
export default {"menu":"Navigation_menu__Mj0M+","active":"Navigation_active__yVppd"};